import { resolveComponent as _resolveComponent, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "col-xxl-12" }
const _hoisted_2 = /*#__PURE__*/_createVNode("div", { class: "card-header border-0 pt-5" }, [
  /*#__PURE__*/_createVNode("h3", { class: "card-title align-items-start flex-column" }, [
    /*#__PURE__*/_createVNode("span", { class: "card-label fw-bolder fs-3 mb-1" }, "Your Personal Points")
  ])
], -1)
const _hoisted_3 = { class: "card-body py-3" }
const _hoisted_4 = { class: "table-responsive" }
const _hoisted_5 = { class: "table align-middle gs-0 gy-4" }
const _hoisted_6 = /*#__PURE__*/_createVNode("thead", null, [
  /*#__PURE__*/_createVNode("tr", { class: "fw-bolder text-muted bg-light" }, [
    /*#__PURE__*/_createVNode("th", { class: "ps-4 min-w-200px rounded-start" }, "July"),
    /*#__PURE__*/_createVNode("th", { class: "min-w-200px" }, "August"),
    /*#__PURE__*/_createVNode("th", { class: "min-w-225px" }, "September"),
    /*#__PURE__*/_createVNode("th", { class: "min-w-200px" }, "October"),
    /*#__PURE__*/_createVNode("th", { class: "min-w-200px" }, "November"),
    /*#__PURE__*/_createVNode("th", { class: "min-w-200px" }, "December")
  ])
], -1)
const _hoisted_7 = { class: "auto-pma-prod-row" }
const _hoisted_8 = /*#__PURE__*/_createVNode("div", { class: "card-header border-0 pt-5" }, [
  /*#__PURE__*/_createVNode("h3", { class: "card-title align-items-start flex-column" }, [
    /*#__PURE__*/_createVNode("span", { class: "card-label fw-bolder fs-3 mb-1" }, "Your EasyVerse Directs")
  ])
], -1)
const _hoisted_9 = { class: "card-body py-3" }
const _hoisted_10 = { class: "table-responsive" }
const _hoisted_11 = { class: "table align-middle gs-0 gy-4" }
const _hoisted_12 = /*#__PURE__*/_createVNode("thead", null, [
  /*#__PURE__*/_createVNode("tr", { class: "fw-bolder text-muted bg-light" }, [
    /*#__PURE__*/_createVNode("th", { class: "ps-4 min-w-125px rounded-start" }, "#"),
    /*#__PURE__*/_createVNode("th", { class: "min-w-200px" }, "User ID"),
    /*#__PURE__*/_createVNode("th", { class: "min-w-225px" }, "Fullname"),
    /*#__PURE__*/_createVNode("th", { class: "min-w-200px" }, "Rank"),
    /*#__PURE__*/_createVNode("th", { class: "min-w-200px" }, "Directs"),
    /*#__PURE__*/_createVNode("th", { class: "min-w-200px" }, "Pairs")
  ])
], -1)
const _hoisted_13 = { class: "row text-center py-10 px-10" }
const _hoisted_14 = { class: "col-md-12" }
const _hoisted_15 = {
  key: 0,
  class: "svg-icon svg-icon-5tx svg-icon-success me-4"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_skeleton = _resolveComponent("el-skeleton")
  const _component_inline_svg = _resolveComponent("inline-svg")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _withDirectives(_createVNode("div", null, [
      _createVNode(_component_el_skeleton, {
        rows: 10,
        animated: ""
      })
    ], 512), [
      [_vShow, _ctx.loading]
    ]),
    _withDirectives(_createVNode("div", _hoisted_1, [
      _createVNode("div", {
        class: [_ctx.widgetClasses, "card"]
      }, [
        _hoisted_2,
        _createVNode("div", _hoisted_3, [
          _createVNode("div", _hoisted_4, [
            _createVNode("table", _hoisted_5, [
              _hoisted_6,
              _createVNode("tbody", null, [
                _createVNode("tr", _hoisted_7, [
                  _createVNode("td", null, "  " + _toDisplayString(_ctx.numberWithCommas(Number(_ctx.personalPoints.july).toFixed(4))), 1),
                  _createVNode("td", null, _toDisplayString(_ctx.numberWithCommas(Number(_ctx.personalPoints.aug).toFixed(4))), 1),
                  _createVNode("td", null, _toDisplayString(_ctx.numberWithCommas(Number(_ctx.personalPoints.sept).toFixed(4))), 1),
                  _createVNode("td", null, _toDisplayString(_ctx.numberWithCommas(Number(_ctx.personalPoints.oct).toFixed(4))), 1),
                  _createVNode("td", null, _toDisplayString(_ctx.numberWithCommas(Number(_ctx.personalPoints.nov).toFixed(4))), 1),
                  _createVNode("td", null, _toDisplayString(_ctx.numberWithCommas(Number(_ctx.personalPoints.december).toFixed(4))), 1)
                ])
              ])
            ])
          ])
        ]),
        _hoisted_8,
        _createVNode("div", _hoisted_9, [
          _createVNode("div", _hoisted_10, [
            _createVNode("table", _hoisted_11, [
              _hoisted_12,
              _createVNode("tbody", null, [
                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.list, (item, index) => {
                  return (_openBlock(), _createBlock("tr", {
                    key: index,
                    class: "auto-pma-prod-row",
                    style: item.isOK == 1 ? 'background-color: #D6EEEE;' : ''
                  }, [
                    _createVNode("td", null, "  " + _toDisplayString(item.ID), 1),
                    _createVNode("td", null, _toDisplayString(item.usid), 1),
                    _createVNode("td", null, _toDisplayString(item.fullname), 1),
                    _createVNode("td", null, _toDisplayString(item.userRank), 1),
                    _createVNode("td", null, _toDisplayString(item.easyVerseDirects), 1),
                    _createVNode("td", null, _toDisplayString(item.pairCount), 1)
                  ], 4))
                }), 128))
              ])
            ])
          ]),
          _createVNode("div", _hoisted_13, [
            _createVNode("div", _hoisted_14, [
              (_ctx.isOverallOK == true)
                ? (_openBlock(), _createBlock("span", _hoisted_15, [
                    _createVNode(_component_inline_svg, { src: "media/icons/duotone/General/GreenCheck.svg" })
                  ]))
                : _createCommentVNode("", true)
            ])
          ])
        ])
      ], 2)
    ], 512), [
      [_vShow, !_ctx.loading]
    ])
  ], 64))
}